import { cn } from '@/ui/lib/utils';
import './icon.css';

interface IconProps {
    src: string;
    size?: 'small' | 'medium' | 'large' | 'extra-large';
    alt?: string;
    className?: string;
}

export const Icon = ({ src, alt, size, className }: IconProps) => (
    <div className={cn('icon', size && `icon--${size}`, className)}>
        <img src={src} alt={alt} />
    </div>
);
